import React, {useEffect, useState} from "react";


const GrossWeight = (props) => {

    const {
        idItem,
        elemArray,
        isRouteOrdersBodyRequest,
        formik
    } = props;

    const [grossWeightRouteOrder, setGrossWeightRouteOrder] = useState({
        indexGoods: null,
        valueGoods: ''
    });

    useEffect(() => {
        let isMounted = true;

        const filteredGoods = formik.values.goods?.find((value, index) => value.id === grossWeightRouteOrder.indexGoods)
        const changedGoodsItem = {...filteredGoods, grossWeight: grossWeightRouteOrder.valueGoods};
        const updatedGoods = formik.values?.goods?.map((el, index) => el.id === grossWeightRouteOrder.indexGoods ? changedGoodsItem : el);
        isMounted && formik.setFieldValue('goods', updatedGoods)

        return () => {
            isMounted = false;
        }
    },[grossWeightRouteOrder])

    return (
        <div>
            <input
                className="route-order-modal__table-row-input"
                type={'number'}
                defaultValue={isRouteOrdersBodyRequest.length !== 0 ? elemArray?.grossWeight : grossWeightRouteOrder.valueGoods}
                onChange={(e) => setGrossWeightRouteOrder({indexGoods: idItem, valueGoods: e.currentTarget.value})}
            />
        </div>
    )
}
export default GrossWeight;